// @flow
import { ResourceResponseContext } from "components/ResourceFill/providers/ResourceResponseProvider";
import { ResourceSharedContext } from "components/ResourceFill/providers/ResourceSharedProvider";
import useQuery from "hooks/useQuery";
import type { UseSignatureMemo } from "hooks/useSignatureMemo";
import PDFFiller from "pages/PDFFiller";
import * as React from "react";

type Props = {
  signatureMemo: UseSignatureMemo,
};

function ResourceFillBodyDocument({ signatureMemo }: Props): React.Node {
  const query = useQuery();
  const { mode, isTablet } = React.useContext(ResourceSharedContext) || {};
  const { response } = React.useContext(ResourceResponseContext) || {};

  if (!response) return null;

  return (
    <PDFFiller
      allowResubmit
      hideFooter
      isPacket
      isKiosk={query.get("isKiosk") === "true"}
      isTablet={isTablet}
      preloadedResponse={response.document_response}
      resourceId={response.id}
      response={response}
      signatureMemo={signatureMemo}
      viewMode={mode === "office" ? "office-use" : "fill"}
    />
  );
}

export default ResourceFillBodyDocument;
